"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@formily/react");
var react_eva_1 = require("react-eva");
exports.createSchemaFormActions = function () {
    return react_eva_1.mergeActions(react_1.createFormActions(), react_eva_1.createActions('getSchema', 'getFormSchema'));
};
exports.createAsyncSchemaFormActions = function () {
    return react_eva_1.mergeActions(react_1.createAsyncFormActions(), react_eva_1.createAsyncActions('getSchema', 'getFormSchema'));
};
